(() => {
  const saved = new Map();
  let checkoutBusy = false;

  function getConsent(form) {
    if (form.classList.contains('mini-cart')) return form.querySelector('[data-kk-cart-consent]');
    if (form.classList.contains('cart__contents')) return document.querySelector('#main-cart-footer [data-kk-cart-consent]');
    return null;
  }

  function fields(consent) {
    return {
      acceptance: consent.querySelector('[data-kk-acceptance]'),
      error: consent.querySelector('[data-kk-consent-error]'),
    };
  }

  function setError(consent, message, target) {
    const { error } = fields(consent);
    error.textContent = message;
    error.hidden = !message;
    consent.classList.toggle('has-error', Boolean(message));
    if (target) {
      target.setAttribute('aria-invalid', 'true');
      target.scrollIntoView({ block: 'nearest' });
      target.focus({ preventScroll: true });
    }
  }

  function remember(consent) {
    saved.set(consent.dataset.kkScope, fields(consent).acceptance.checked);
  }

  function initialize() {
    document.querySelectorAll('[data-kk-cart-consent]:not([data-kk-ready])').forEach((consent) => {
      const previous = saved.get(consent.dataset.kkScope);
      if (previous !== undefined) fields(consent).acceptance.checked = previous;
      consent.dataset.kkReady = 'true';
    });
  }

  function validate(consent) {
    const { acceptance } = fields(consent);
    acceptance.removeAttribute('aria-invalid');
    if (!acceptance.checked) {
      setError(consent, window.KKText.consent_required, acceptance);
      return false;
    }
    setError(consent, '');
    return true;
  }

  document.addEventListener('input', (event) => {
    const consent = event.target.closest('[data-kk-cart-consent]');
    if (!consent) return;
    event.target.removeAttribute('aria-invalid');
    setError(consent, '');
    remember(consent);
  });
  document.addEventListener('change', (event) => {
    const consent = event.target.closest('[data-kk-cart-consent]');
    if (!consent) return;
    event.target.removeAttribute('aria-invalid');
    setError(consent, '');
    remember(consent);
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('button[name="checkout"]');
    if (!button) return;
    const form = button.form;
    const consent = form && getConsent(form);
    if (consent && !validate(consent)) event.preventDefault();
  }, true);

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || event.submitter?.name !== 'checkout') return;
    const consent = getConsent(form);
    if (!consent || form.dataset.kkConsentReady === 'true') {
      delete form.dataset.kkConsentReady;
      return;
    }
    event.preventDefault();
    if (!validate(consent) || checkoutBusy) return;

    checkoutBusy = true;
    const button = event.submitter;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    try {
      // Apps can add lines without the theme's product form, or replace the
      // drawer while properties are updated. Save packing before checkout.
      await window.KKCartPacking.reconcile();
      const timestamp = new Date().toISOString();
      const attributes = {
        'Akceptacja regulaminu': timestamp,
        'Zapoznanie z polityką prywatności': timestamp,
        'Zgoda na newsletter': '',
      };
      const root = window.Shopify?.routes?.root || '/';
      const url = `${root.replace(/\/?$/, '/')}cart/update.js`;
      const response = await fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes }),
      });
      if (!response.ok) throw new Error(`Cart update failed: ${response.status}`);
      const result = await response.json();
      if (result.status || result.errors) throw new Error('Cart update rejected');

      await new Promise((resolve) => requestAnimationFrame(resolve));
      const currentForm = document.getElementById(form.id);
      const currentConsent = currentForm && getConsent(currentForm);
      const currentButton = currentForm && [...document.querySelectorAll('button[name="checkout"]')].find(node => node.form === currentForm);
      if (!currentConsent || !currentButton) throw new Error('Cart form is unavailable');
      if (!validate(currentConsent)) return;
      fields(currentConsent).acceptance.value = timestamp;
      currentForm.dataset.kkConsentReady = 'true';
      currentButton.disabled = false;
      currentForm.requestSubmit(currentButton);
    } catch (error) {
      console.error('Could not save cart consent', error);
      setError(getConsent(document.getElementById(form.id) || form) || consent, window.KKText.consent_save_failed);
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      checkoutBusy = false;
    }
  });

  let scheduled = false;
  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      initialize();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
  initialize();
})();
